module.exports = __webpack_public_path__ + "static/media/au.3413a341.webp";